export let AdminUserGroup = /*#__PURE__*/function (AdminUserGroup) {
  AdminUserGroup["Developer"] = "Developer";
  AdminUserGroup["TechTeam"] = "Tech Team";
  AdminUserGroup["Leadership"] = "Leadership";
  AdminUserGroup["ReleaseSupervisor"] = "Release Supervisor";
  return AdminUserGroup;
}({});